export default "__VITE_ASSET__Cw3aID0a__"